import { render, staticRenderFns } from "./TelephoneBidsList.vue?vue&type=template&id=25242958&scoped=true"
import script from "./TelephoneBidsList.vue?vue&type=script&lang=js"
export * from "./TelephoneBidsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25242958",
  null
  
)

export default component.exports